export const GENERAL_SEARCH_TAGS_REQUEST = 'GENERAL_SEARCH_TAGS_REQUEST';
export const GENERAL_SEARCH_TAGS_RESULT = 'GENERAL_SEARCH_TAGS_RESULT';
export const GENERAL_SEARCH_ENTITY_REQUEST = 'GENERAL_SEARCH_ENTITY_REQUEST';
export const GENERAL_SEARCH_ENTITY_RESULT = 'GENERAL_SEARCH_ENTITY_RESULT';
export const GENERAL_SEARCH_MANUFACTURERS_REQUEST = 'GENERAL_SEARCH_MANUFACTURERS_REQUEST';
export const GENERAL_SEARCH_MANUFACTURERS_RESULT = 'GENERAL_SEARCH_MANUFACTURERS_RESULT';
export const GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST = 'GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST';
export const GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_RESULT = 'GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_RESULT';
export const GENERAL_SEARCH_SIM_PROVIDERS_REQUEST = 'GENERAL_SEARCH_SIM_PROVIDERS_REQUEST';
export const GENERAL_SEARCH_SIM_PROVIDERS_RESULT = 'GENERAL_SEARCH_SIM_PROVIDERS_RESULT';
export const GENERAL_SEARCH_DEVICE_MODELS_REQUEST = 'GENERAL_SEARCH_DEVICE_MODELS_REQUEST';
export const GENERAL_SEARCH_DEVICE_MODELS_RESULT = 'GENERAL_SEARCH_DEVICE_MODELS_RESULT';
export const GENERAL_SEARCH_DEALERS_REQUEST = 'GENERAL_SEARCH_DEALERS_REQUEST';
export const GENERAL_SEARCH_DEALERS_RESULT = 'GENERAL_SEARCH_DEALERS_RESULT';
export const GENERAL_SEARCH_TIMEZONES_REQUEST = 'GENERAL_SEARCH_TIMEZONES_REQUEST';
export const GENERAL_SEARCH_TIMEZONES_RESULT = 'GENERAL_SEARCH_TIMEZONES_RESULT';
export const GENERAL_SAVE_AUDIT_LOG = 'GENERAL_SAVE_AUDIT_LOG';
export const GENERAL_SAVE_AUDIT_LOG_RESULT = 'GENERAL_SAVE_AUDIT_LOG_RESULT';
export const GENERAL_GENERIC_EXPORT_SEND = 'GENERAL_GENERIC_EXPORT_SEND';
export const GENERAL_GENERIC_EXPORT_SEND_RESULT = 'GENERAL_GENERIC_EXPORT_SEND_RESULT';
export const GENERAL_COUNT_PEDING_NOTIFICATIONS = "GENERAL_COUNT_PEDING_NOTIFICATIONS";
export const GENERAL_COUNT_PEDING_NOTIFICATIONS_RESULT = "GENERAL_COUNT_PEDING_NOTIFICATIONS_RESULT";
export const GENERAL_SEARCH_NOTIFICATIONS = "GENERAL_SEARCH_NOTIFICATIONS";
export const GENERAL_SEARCH_NOTIFICATIONS_RESULT = "GENERAL_SEARCH_NOTIFICATIONS_RESULT";
export const GENERAL_UPDATE_NOTIFICATION = "GENERAL_UPDATE_NOTIFICATION";
export const GENERAL_UPDATE_NOTIFICATION_RESULT = "GENERAL_UPDATE_NOTIFICATION_RESULT";
export const GENERAL_SAVE_PREFERENCE = "GENERAL_SAVE_PREFERENCE";
export const GENERAL_GET_PREFERENCE = "GENERAL_GET_PREFERENCE";
export const GENERAL_EXPORT = "GENERAL_EXPORT";
export const GENERAL_SET_TOTAL_RECORDS = "GENERAL_SET_TOTAL_RECORDS";
export const GENERAL_SET_CREATE_NOTIFICATION_ID = "GENERAL_SET_CREATE_NOTIFICATION_ID";
export const GENERAL_CATALOG_INITIAL = "GENERAL_CATALOG_INITIAL";
export const GENERAL_CATALOG_INITIAL_RESULT = "GENERAL_CATALOG_INITIAL_RESULT";
export const GENERAL_DOWNLOAD_REPORT_FILE_REQUEST = "GENERAL_DOWNLOAD_REPORT_FILE_REQUEST";
export const GENERAL_DOWNLOAD_REPORT_FILE_RESULT = "GENERAL_DOWNLOAD_REPORT_FILE_RESULT";
export const GENERAL_EXPORT_PENDING_ADD = "GENERAL_EXPORT_PENDING_ADD";
export const GENERAL_EXPORT_PENDING_COMPLETE = "GENERAL_EXPORT_PENDING_COMPLETE";
export const GENERAL_EXPORT_PENDING_REMOVE = "GENERAL_EXPORT_PENDING_REMOVE";